import type { Medication } from 'src/app/types/medication';

/**
 * This returns the index of a nested Formik field, no matter how deep.
 *
 * - @warn if the `name` of an input field props contain numbers,
 *   this may not behave as intended.
 *
 * @param {string} path - 'doctors[0].medications[0].name'
 *
 * @returns Returns the index (number) of the nested field.
 * - Returns -1 if the path contains no numbers.
 */
export function getIndexOfNestedFieldArray(path: string): number {
  const n = path.match(/\d+/g);
  if (!n) {
    return -1;
  }

  const numbers = n.map(Number);
  const indexOfNestedFieldArray = numbers[numbers.length - 1];

  return indexOfNestedFieldArray;
}

const EMPTY_STRING = '';

export const getMedicationFormValueName = (medication: string | Medication): string => {
  if (typeof medication === 'string') {
    return medication;
  } else {
    const medName = (medication?.attributes?.primaryName as string | undefined) || medication?.name || EMPTY_STRING;
    return medName;
  }
};

export const getMedsRequiringDoctorTransfer = (medications: Medication[]) => {
  return medications.filter(med => {
    if (typeof med === 'string') {
      return false;
    } else {
      return med?.attributes?.doctorRequiredForTransfer == true;
    }
  });
};

export const filterMedicationFormValues = (medications: (string | Medication)[]) => {
  return medications.filter(medication => {
    const medicationName = getMedicationFormValueName(medication);
    const hasAttributes = typeof medication !== 'string' && Object.keys(medication.attributes).length > 0;
    const hasMedicationName = medicationName !== EMPTY_STRING;

    return typeof medication === 'string' ? hasMedicationName : hasMedicationName && hasAttributes;
  });
};

export const getTransferableMeds = (medications: Medication[]) =>
  medications.filter(med => {
    const hasMedName = !!med.attributes?.primaryName;
    const isSimpleMed =
      'doctorRequiredForTransfer' in med.attributes && med.attributes.doctorRequiredForTransfer === false;

    return hasMedName && isSimpleMed;
  });
